import app from './index';

const footer = document.getElementById('vue-footer');

if (footer) {
	app.$mount(footer);
}